import {
  put, call, select,
} from 'lib/redux';
import * as types from 'constants/ActionTypes';
import accountDeletionService from 'services/accountDeletion.service';
import { getInitParametersSaga, getUserProfileSaga } from 'features/userData/UserData.saga';
import { logError, logCritical } from 'utils/logger.utils';

export default function* deleteAccountSaga() {
  try {
    yield put({ type: types.DELETING_ACCOUNT });
    yield call(getInitParametersSaga);
    yield call(getUserProfileSaga);

    const { email } = yield select(({ userData }) => userData.userProfile);

    const { customerId, orgNodeId } = yield select(({ userData: { initParameters } }) => initParameters);
    const requestBody = { customer_email: email, customer_id: String(customerId), orgnodeid: String(orgNodeId) };

    const deleteResponse = yield call(accountDeletionService, requestBody);
    if (!deleteResponse.ok) {
      const error = new Error(deleteResponse.errorDescription);
      error.errorCode = deleteResponse.errorCode;
      logError('Account deletion request failed', {
        error: error.message,
        errorCode: error.errorCode,
        customerId,
        orgNodeId,
      });
      throw error;
    }
    yield put({ type: types.DELETE_ACCOUNT_SUCCESS });
  } catch (err) {
    logCritical('Account deletion process failed', {
      error: err.message,
      errorCode: err.errorCode,
    });
    yield put({ type: types.DELETE_ACCOUNT_FAILURE });
  }
}
